/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import liveSearchHelperData from './data.js'
import liveSearchHelperDevices from './devices.js'
import liveSearchHelperLayout from './layout.js'
import liveSearchHelperReset from './reset.js'
import liveSearchHelperResponsive from './responsive.js'
import liveSearchHelperState from './state.js'
import liveSearchHelperTrbo from './trbo.js'
import liveSearchHelperHeading from './heading.js'

const liveSearchHelper = {
    ...liveSearchHelperData,
    ...liveSearchHelperDevices,
    ...liveSearchHelperLayout,
    ...liveSearchHelperReset,
    ...liveSearchHelperResponsive,
    ...liveSearchHelperState,
    ...liveSearchHelperHeading,
    ...liveSearchHelperTrbo
}

export default liveSearchHelper
